import React from "react";
import { DEFAULT_FORM_VALUES } from "../constants/wasteRecords.constants";
import { MgmtOption, WasteFormValues } from "../types/wasteRecords.types";
import WasteRecordForm from "./WasteRecordForm";

interface WasteAddRecordPanelProps {
  /** Bumped after a successful add to remount the form with a blank draft. */
  draftKey: number;
  hasRecords: boolean;
  onSave: (values: WasteFormValues) => void;
  ingredientOptions: string[];
  mgmtOptions: MgmtOption[];
}

/** Dashed "add a new waste record" panel shown at the bottom of the list. */
const WasteAddRecordPanel: React.FC<WasteAddRecordPanelProps> = ({
  draftKey,
  hasRecords,
  onSave,
  ingredientOptions,
  mgmtOptions
}) => (
  <>
    {hasRecords && <div className="tw-border-t tw-border-dashed tw-border-border" />}
    <div className="tw-space-y-2">
      <p className="tw-text-[10px] tw-text-muted-foreground">Add new waste record</p>
      <div className="tw-border tw-border-dashed tw-border-primary/30 tw-rounded-md tw-p-3 tw-bg-primary/5">
        <WasteRecordForm
          key={draftKey}
          defaultValues={DEFAULT_FORM_VALUES}
          onSave={onSave}
          ingredientOptions={ingredientOptions}
          mgmtOptions={mgmtOptions}
        />
      </div>
    </div>
  </>
);

export default WasteAddRecordPanel;
